'use strict';

(function ($) {

	/**
  * LinksDownloads
  *
  * @author Zorica Janjic <zorica.janjic@namics.com>
  */
	T.Module.LinksDownloads = T.createModule({

		_stateClasses: {
			open: 'state-open',
			hover: 'state-hover'
		},

		_selectors: {
			tileWrapper: '[data-js-m-links-downloads__tile-wrapper]',
			header: '[data-js-m-links-downloads__header]',
			content: '[data-js-m-links-downloads__content]'
		},

		start: function start(resolve) {
			this.$ctx = $(this._ctx);

			this.$tileWrapper = this.$ctx.find(this._selectors.tileWrapper);

			this.initializeTile();

			resolve();
		},


		/**
   * Initialize the tile behaviour
   *
   * @returns {undefined} void
   */
		initializeTile: function initializeTile() {
			var _this = this;

			$.each(this.$tileWrapper, function (index, tile) {
				var $tile = $(tile);
				var handlerIn = function handlerIn() {
					return $tile.addClass(_this._stateClasses.hover);
				};
				var handlerOut = function handlerOut() {
					return $tile.removeClass(_this._stateClasses.hover);
				};

				$tile.find(_this._selectors.header).on('click', _this.onTileHeaderClick.bind(_this));

				// -----------------------------------------------------------
				//	state-hover is used for styling of the open/close icon
				$tile.find(_this._selectors.header).hover(handlerIn, handlerOut);
			});
		},


		/**
   * Open the tile which was clicked on
   *
   * @param {event} event The click event
   * @returns {undefined} void
   */
		onTileHeaderClick: function onTileHeaderClick(event) {
			event.stopPropagation();

			var $tileWrapper = $(event.currentTarget).closest(this._selectors.tileWrapper);

			$tileWrapper.toggleClass(this._stateClasses.open);
			$tileWrapper.removeClass(this._stateClasses.hover);
			$tileWrapper.find(this._selectors.content).slideToggle('swing');
		}
	});
})(jQuery);